(function () {
  const MOBILE_MQ = window.matchMedia('(max-width: 749px)');

  function initDescription(block) {
    const inner = block.querySelector('.product-description__inner');
    const toggle = block.querySelector('.product-description__toggle');
    const label = block.querySelector('.product-description__toggle-label');
    if (!inner || !toggle || !label) return;

    const maxHeight = parseInt(block.dataset.maxHeight, 10) || 280;
    block.style.setProperty('--product-desc-max-height', maxHeight + 'px');

    const expandText = label.textContent.trim();
    const collapseText = toggle.getAttribute('data-collapse') || 'Show less';

    function sync() {
      if (!MOBILE_MQ.matches) {
        block.classList.remove('is-collapsed', 'is-expanded');
        toggle.hidden = true;
        toggle.setAttribute('aria-expanded', 'true');
        return;
      }

      const needsToggle = inner.scrollHeight > maxHeight + 8;
      if (!needsToggle) {
        block.classList.remove('is-collapsed', 'is-expanded');
        toggle.hidden = true;
        toggle.setAttribute('aria-expanded', 'true');
        return;
      }

      toggle.hidden = false;
      if (!block.classList.contains('is-expanded')) {
        block.classList.add('is-collapsed');
        block.classList.remove('is-expanded');
        label.textContent = expandText;
        toggle.setAttribute('aria-expanded', 'false');
      }
    }

    toggle.addEventListener('click', function () {
      const expanded = block.classList.toggle('is-expanded');
      block.classList.toggle('is-collapsed', !expanded);
      label.textContent = expanded ? collapseText : expandText;
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });

    sync();

    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(sync);
      ro.observe(inner);
    }

    MOBILE_MQ.addEventListener('change', sync);
    window.addEventListener('load', sync);
  }

  function boot() {
    document
      .querySelectorAll('.product-description--collapsible-mobile')
      .forEach(initDescription);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
